// extracted by mini-css-extract-plugin
module.exports = {"customInputContainer":"style_customInputContainer__3z-K5","label":"style_label__3NgHw"};